export default import.meta.ROLLDOWN_FILE_URL_TASb5u061I6_DFQjxqjx_g